/*
 * Override WISHLIST_PAGE_SIZE param
 */

export const WISHLIST_STATE = {
	DEFAULT: 'Default',
	ACTIVE: 'Active',
	SAVE_FOR_LATER: 'SaveForLater',
};

export const DEFAULT_WISHLIST_PRODUCT_QUANTITY = '1';

export const WISHLIST_PAGE_SIZE = 200;

export const WISHLIST_DETAILS_PAGE_SIZE = 3;

export const WISHLIST_DETAILS_NAME_MAX_LENGTH = 128;

export const WISHLIST_NAME_INPUT_MAX_LENGTH = 50;

export const WISHLIST_DETAILS_DIALOG_STATE_MULTI = 'multi';

export const WISHLIST_DETAILS_DIALOG_STATE_LIST = 'list';

export const WL_NAME_REGEX = /^[a-zA-Z0-9 ñÑáéíóúÁÉÍÓÚ]*$/;
